import { useTracking } from 'react-tracking';

import { useIsMobileScreen } from '@/hooks/useMedia';
import { useUserAgent } from '@simplywallst/hooks/useUserAgent';

import { Bones } from '@simplywallst/ui-core';
import { useUserNotes } from '@/components/Note/hooks/useUserNotes';
import { useCompanyNoteModal } from '@/components/Note/components/CompanyNoteModalContext';
import { Text, Box, Heading } from '@simplywallst/ui-core';
import If from '@/components/If';

import { Note, TickerSymbol, TableRow, DataTable, CellLink } from './styled';

export const MyRecentNotes = () => {
  const { isMobile } = useUserAgent();
  const isMobileScreen = useIsMobileScreen({ defaultMatches: isMobile });

  const { openNoteModal } = useCompanyNoteModal();
  const { data: notes, status } = useUserNotes();
  const { Track, trackEvent } = useTracking({
    type: 'track',
    subject: 'RecentNotes',
  });

  return (
    <Track>
      <Box as="section" marginBottom="x4">
        {!isMobileScreen && (
          <Box marginTop="x1" marginBottom="x2">
            <Heading
              as="h1"
              typography="xSmall"
              color="whiteRGBA"
              opacity={0.7}
            >
              My Recent Notes
            </Heading>
          </Box>
        )}
        <DataTable
          columnTextAlignments="l"
          data-cy-id="dashboard-recent-notes-table"
        >
          <tbody>
            <If match={status === 'success' && notes?.length === 0}>
              <TableRow>
                <td>
                  <Box
                    paddingY="x1_25"
                    paddingX="x1"
                    backgroundColor="transparent"
                    cursor="auto"
                    minHeight="40px"
                  >
                    <Text
                      typography="tiny"
                      color="whiteRGBA"
                      textAlign="center"
                      opacity={0.5}
                    >
                      You don't have any notes yet
                    </Text>
                  </Box>
                </td>
              </TableRow>
            </If>
            {typeof notes !== 'undefined' &&
              notes.map(
                (n, i) =>
                  n.company && (
                    <TableRow
                      data-cy-id="dashboard-recent-notes-item"
                      key={`${i}-${n.company.id}`}
                    >
                      <Note>
                        <CellLink
                          onClick={(e) => {
                            e.preventDefault();
                            openNoteModal({
                              companyId: n.company.id,
                              uniqueSymbol: n.company.tickerSymbol,
                              note: n,
                            });
                            trackEvent({
                              type: 'track',
                              action: 'click',
                              ticker: n.company.tickerSymbol,
                              companyId: n.company.id,
                            });
                          }}
                        >
                          <TickerSymbol>{n.company.tickerSymbol} </TickerSymbol>
                          <Text as="span" color="whiteRGBA" opacity={0.5}>
                            {n.contentPreview}
                          </Text>
                        </CellLink>
                      </Note>
                    </TableRow>
                  )
              )}
            <If match={status === 'pending'}>
              <TableRow>
                <td>
                  <span>
                    <Bones />
                  </span>
                </td>
              </TableRow>
            </If>
          </tbody>
        </DataTable>
      </Box>
    </Track>
  );
};
